import api from '@/utils/api'

export default {
    getCups(page, size) {
        let range = '?range=' + encodeURIComponent(`[${page - 1},${size}]`)
        return api.get(`cup-leagues` + (page ? range : ''))
    },

    getCup(id) {
        return api.get(`cup-leagues/${id}`)
    },

    getAllActiveCups() {
        let query = '?filter=' + encodeURIComponent('{"active": true }')
        return api.get(`cup-leagues` + query)
    },

    getAllCups() {
        return api.get(`cup-leagues/all`)
    },

    updateCup(id, data) {
        return api.put(`cup-leagues/${id}`, data)
    },

    createCup(data) {
        return api.post('cup-leagues', data)
    },

    deleteCup(id) {
        return api.delete(`cup-leagues/${id}`)
    }
}
